import { Route, Routes } from 'react-router';
import loadable from '@loadable/component';
import { ContentLoader } from '@edikk-edikk/country-common';
import { useRoutePrefix } from '@edikk-edikk/hooks';
import { useErrorState } from '@edikk-edikk/redux';
import { DynamicPages } from '#base/components/DynamicPages';

const Home = loadable(() => import('#home/containers/Home'), {
  fallback: <ContentLoader />,
});

const Login = loadable(() => import('#userLogin/containers/Login'), {
  fallback: <ContentLoader />,
  resolveComponent: ({ Login: Component }) => Component,
});

const Registration = loadable(() => import('#userRegistration/containers/Registration'), {
  fallback: <ContentLoader />,
  resolveComponent: ({ Registration: Component }) => Component,
});

const ForgotPassword = loadable(() => import('#userForgotPassword/containers/ForgotPassword'), {
  fallback: <ContentLoader />,
  resolveComponent: ({ ForgotPassword: Component }) => Component,
});

const ResetPassword = loadable(() => import('#userResetPassword/containers/ResetPassword'), {
  fallback: <ContentLoader />,
  resolveComponent: ({ ResetPassword: Component }) => Component,
});

const ReviewList = loadable(() => import('#reviewList/containers/ReviewList'), {
  fallback: <ContentLoader />,
});

const Routers = () => {
  const { error } = useErrorState();
  const routePrefix = useRoutePrefix();

  if (error) {
    return null;
  }

  return (
    <Routes>
      <Route
        path={`${routePrefix}/`}
        element={<Home />}
      />
      <Route
        path={`${routePrefix}/login`}
        element={<Login />}
      />
      <Route
        path={`${routePrefix}/registration`}
        element={<Registration />}
      />
      <Route
        path={`${routePrefix}/forgot-password`}
        element={<ForgotPassword />}
      />
      <Route
        path={`${routePrefix}/reset-password`}
        element={<ResetPassword />}
      />
      <Route
        path={`${routePrefix}/escort-reviews`}
        element={<ReviewList />}
      />
      <Route
        path={`${routePrefix}/*`}
        element={<DynamicPages />}
      />
    </Routes>
  );
};

export { Routers };
